// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Общий контейнер для страницы */
.auth-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f0f0f0;
}

/* Форма входа/регистрации */
.auth-form {
    background-color: #fff;
    padding: 30px;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    width: 350px;
}

/* Заголовок формы */
.auth-form h2 {
    text-align: center;
    margin-bottom: 20px;
    color: #333;
}

/* Группа формы */
.form-group {
    margin-bottom: 15px;
}

/* Метка для полей ввода */
.form-group label {
    display: block;
    margin-bottom: 5px;
    color: #555;
    font-weight: bold;
}

/* Поля ввода */
.form-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    box-sizing: border-box;
}

/* Стиль при фокусе на поле ввода */
.form-group input:focus {
    border-color: #007bff;
    outline: none;
    box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);
}

/* Кнопка отправки формы */
.auth-form button {
    background-color: #007bff;
    color: white;
    padding: 12px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    width: 100%;
    font-size: 16px;
}

/* Эффект при наведении на кнопку */
.auth-form button:hover {
    background-color: #0056b3;
}

/* Сообщение об ошибке */
.error-message {
    color: #dc3545;
    margin-top: 10px;
    text-align: center;
}

/* Кнопка для переключения между регистрацией и входом */
.auth-form button.switch {
    background-color: transparent;
    color: #007bff;
    padding: 8px;
    font-size: 14px;
    border: none;
    cursor: pointer;
    text-align: center;
}

/* Эффект при наведении на кнопку переключения */
.auth-form button.switch:hover {
    text-decoration: underline;
}

/* Дополнительный текст и ссылка */
.auth-form p {
    margin-top: 15px;
    text-align: center;
}

.auth-form a {
    color: #007bff;
    text-decoration: none;
}

.auth-form a:hover {
    text-decoration: underline;
}
`, "",{"version":3,"sources":["webpack://./src/modules/Base/Auth/pages/authPage.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI,sBAAsB;IACtB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;IACxC,YAAY;AAChB;;AAEA,oBAAoB;AACpB;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,mBAAmB;AACvB;;AAEA,0BAA0B;AAC1B;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,mCAAmC;AACnC;IACI,qBAAqB;IACrB,aAAa;IACb,gDAAgD;AACpD;;AAEA,0BAA0B;AAC1B;IACI,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;AAC7B;;AAEA,wBAAwB;AACxB;IACI,cAAc;IACd,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,wDAAwD;AACxD;IACI,6BAA6B;IAC7B,cAAc;IACd,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA,gDAAgD;AAChD;IACI,0BAA0B;AAC9B;;AAEA,kCAAkC;AAClC;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B","sourcesContent":["/* Общий контейнер для страницы */\r\n.auth-container {\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    background-color: #f0f0f0;\r\n}\r\n\r\n/* Форма входа/регистрации */\r\n.auth-form {\r\n    background-color: #fff;\r\n    padding: 30px;\r\n    border-radius: 8px;\r\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\r\n    width: 350px;\r\n}\r\n\r\n/* Заголовок формы */\r\n.auth-form h2 {\r\n    text-align: center;\r\n    margin-bottom: 20px;\r\n    color: #333;\r\n}\r\n\r\n/* Группа формы */\r\n.form-group {\r\n    margin-bottom: 15px;\r\n}\r\n\r\n/* Метка для полей ввода */\r\n.form-group label {\r\n    display: block;\r\n    margin-bottom: 5px;\r\n    color: #555;\r\n    font-weight: bold;\r\n}\r\n\r\n/* Поля ввода */\r\n.form-group input {\r\n    width: 100%;\r\n    padding: 10px;\r\n    border: 1px solid #ddd;\r\n    border-radius: 4px;\r\n    box-sizing: border-box;\r\n}\r\n\r\n/* Стиль при фокусе на поле ввода */\r\n.form-group input:focus {\r\n    border-color: #007bff;\r\n    outline: none;\r\n    box-shadow: 0 0 0 0.1rem rgba(0, 123, 255, 0.25);\r\n}\r\n\r\n/* Кнопка отправки формы */\r\n.auth-form button {\r\n    background-color: #007bff;\r\n    color: white;\r\n    padding: 12px;\r\n    border: none;\r\n    border-radius: 4px;\r\n    cursor: pointer;\r\n    width: 100%;\r\n    font-size: 16px;\r\n}\r\n\r\n/* Эффект при наведении на кнопку */\r\n.auth-form button:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n/* Сообщение об ошибке */\r\n.error-message {\r\n    color: #dc3545;\r\n    margin-top: 10px;\r\n    text-align: center;\r\n}\r\n\r\n/* Кнопка для переключения между регистрацией и входом */\r\n.auth-form button.switch {\r\n    background-color: transparent;\r\n    color: #007bff;\r\n    padding: 8px;\r\n    font-size: 14px;\r\n    border: none;\r\n    cursor: pointer;\r\n    text-align: center;\r\n}\r\n\r\n/* Эффект при наведении на кнопку переключения */\r\n.auth-form button.switch:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n/* Дополнительный текст и ссылка */\r\n.auth-form p {\r\n    margin-top: 15px;\r\n    text-align: center;\r\n}\r\n\r\n.auth-form a {\r\n    color: #007bff;\r\n    text-decoration: none;\r\n}\r\n\r\n.auth-form a:hover {\r\n    text-decoration: underline;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
